var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FloatingArrow } from '@floating-ui/react';
import { C } from '#integrations';
import { randomId } from '#services';
import { Box } from '../Box';
import { Typography } from '../Typography';
import { TooltipTestIdFactory } from './interactions';
import styles from './Tooltip.module.css';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-17357 - Investigate option to render outside App DOM
export const Tooltip = ({ className, contents, 'data-testid': testId, tooltipProps, }) => {
    return (_jsxs("div", { ...tooltipProps.targetProps, className: C(styles.Container, className), ...(testId && {
            'data-testid': TooltipTestIdFactory.getTooltipTestId(testId),
        }), children: [_jsx(Box, { gap: 's', orientation: "vertical", children: contents.map((content) => (_jsx(Typography, { color: "inverted", kind: "p-tiny", children: content }, randomId()))) }), _jsx(FloatingArrow, { ...tooltipProps.arrowProps, className: styles.Arrow })] }));
};
_react_refresh_temp_1 = Tooltip;
$RefreshReg$(_react_refresh_temp_1, "Tooltip");
